export const
    PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE="PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE",
    PAGE_GO_TO_CREATE_COMPLAINT_CUSTOMER_PAGE="PAGE_GO_TO_CREATE_COMPLAINT_CUSTOMER_PAGE",
    PAGE_GO_TO_CREATE_COMPLAINT_PAGE="PAGE_GO_TO_CREATE_COMPLAINT_PAGE",
    PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR="PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR",
    PAGE_GO_TO_CREATE_COMPLAINT_POSITIONS_PAGE="PAGE_GO_TO_CREATE_COMPLAINT_POSITIONS_PAGE",
    PAGE_GO_TO_CREATE_COMPLAINT_POSITION_PAGE="PAGE_GO_TO_CREATE_COMPLAINT_POSITION_PAGE",
    PAGE_GO_TO_CREATE_COMPLAINT_POST_ISSUE_PAGE="PAGE_GO_TO_CREATE_COMPLAINT_POST_ISSUE_PAGE",
    PAGE_GO_TO_CREATE_COMPLAINT_PREVIEW_PAGE="PAGE_GO_TO_CREATE_COMPLAINT_PREVIEW_PAGE",
    PAGE_GO_TO_CREATE_SINGLE_COMPLAINT_POSITION_PAGE="PAGE_GO_TO_CREATE_SINGLE_COMPLAINT_POSITION_PAGE",
    PAGE_GO_TO_START_PAGE="PAGE_GO_TO_START_PAGE";


// WEBPACK FOOTER //
// ./src/types/Page.js